import { HelmetDexteel } from "@dexteel/mesf-core";
import { BarrelsManager } from "./components/BarrelsManager";

export const BarrelsPage = () => {
	return (
		<>
			<HelmetDexteel title="Barrels Configuration" />
			<BarrelsManager />
		</>
	);
};
